import * as React from 'react'
import { Pagination } from '@amzn/dvui/dist/Pagination'
import { QueryParameters } from 'DVWebNodeUtils'
import { int } from '../../utils/utils'
import { paginator } from '../../utils/paginator'
import { detailPagePath } from '../../utils/url'
import { collectionTypes, CollectionType } from './collectionTypes'
import { IDetailPageState } from '../../reducers'
import { connect } from 'react-redux'
import {
  sanitizedRequestContextSelector,
  IRequestContext
} from '../../selectors/requestContext'
import { DpWidgetContext } from '../../utils/dpWidgetContext'

export const DEFAULT_PAGE_SIZE = 200
export const DEFAULT_TOTAL_ITEMS_LIMIT = 10000

type IStateProps = {
  requestContext: IRequestContext
  pageTitleId: string
}

type Params = {[key: string]: string}
const paginationParams: Params = collectionTypes.reduce((params, type) => (
  { ...params, [type]: `${type}From`}
), {})

const getCurrentOffsets = (parameters: QueryParameters) => (
  Object.keys(paginationParams).reduce((params, type) => {
    const paramName = paginationParams[type]
    if (paramName && parameters[paramName]) {
      params[paramName] = parameters[paramName][0] as string
    }
    return params
  }, {} as Params)
)

export const getCollectionCurrentOffset = (parameters: QueryParameters, collectionType: CollectionType): number => {
  const paginationParam = paginationParams[collectionType]
  const offsetValue = parameters && paginationParam && parameters[paginationParam] && parameters[paginationParam][0]
  return int(offsetValue)
}

export type ICollectionPaginationProps = {
  totalEpisodeSize: number
  collectionType: CollectionType
} & IStateProps

const PaginationWithContext = ({
  totalEpisodeSize,
  requestContext: { queryParameters, makeUrl },
  collectionType,
  pageTitleId
}: ICollectionPaginationProps) => {
  const { getString } = React.useContext(DpWidgetContext)
  // Only show pagination for Episodes and Bonus collections for now
  if (!['episodes', 'bonus'].includes(collectionType)) {
    return null
  }

  const linkMaker = (itemOffset: number, refMarkerSuffix: string) => {
    const get = {
      ...getCurrentOffsets(queryParameters),
      [paginationParams[collectionType]]: `${itemOffset}`,
    }
    const refTag = `dv_dp_${collectionType}_${refMarkerSuffix}`
    return makeUrl(detailPagePath(pageTitleId), {get, refTag})
  }

  const paginatorArgs = {
    currentOffset: getCollectionCurrentOffset(queryParameters, collectionType),
    totalItems: totalEpisodeSize,
    pageSize: DEFAULT_PAGE_SIZE,
    paginationHardLimit: DEFAULT_TOTAL_ITEMS_LIMIT,
    linkMaker,
    strings: {
      page: (pageNumber: string) => getString('DV_WEB_PAGINATION_PAGE', { pageNumber }),
      previous: getString('DV_WEB_PAGINATION_PREVIOUS'),
      next: getString('DV_WEB_PAGINATION_NEXT'),
    }
  }

  return (
    <Pagination paginator={paginator(paginatorArgs)} />
  )
}

const mapStateToProps = (state: IDetailPageState): IStateProps => ({
  requestContext: sanitizedRequestContextSelector(state),
  pageTitleId: state.pageTitleId
})

export const CollectionPagination = connect(mapStateToProps)(PaginationWithContext)
